import Promise from 'bluebird';
import _ from 'lodash';
import {Persurl} from 'generated/JavaTOmodifications'
import axios from 'axios'

class CollisionError extends Error {
	collisions: Persurl[]

	constructor(collisions: Persurl[]) {
		super();
		this.collisions = collisions;
	}
}

export function checkPersurlRemoteCollision(persistedModel: null | Persurl, model: Partial<Persurl>, {checkRemoteCollision}: { checkRemoteCollision?: boolean }) {
	if (!checkRemoteCollision) return Promise.resolve();
	//check on server
	const id = persistedModel && persistedModel.id;
	const {persNr, start, end} = model;
	return axios.get<Persurl[]>('../json/persurls', {
		params: {
			pnrLst: persNr,
			start,
			end,
		},
	}).then(function ({data: conflictingPersurls}) {
		if (id) {
			conflictingPersurls = _.filter(conflictingPersurls, c => id !== c.id);
		}
		// server collision found?
		if (conflictingPersurls.length) {
			throw new CollisionError(conflictingPersurls);
		}
	});
}